var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#4d4d4d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.0697 9.94055v-3.76225c0-.23007-.1865-.41658-.4166-.41658h-13.79665v9.43368c0 .2301.18651.4166.41658.4166h6.05286",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.85645 5.94559v-2.29708c0-.20307.07468-.39783.20763-.54143.13295-.14359.31326-.22426.50127-.22426h4.66994c.09205-.00035.18327.01891.26842.05669.08515.03777.16256.09331.22782.16344l2.43847 2.64257",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.0735 15.0136c.2512 0 .4567-.2046.4567-.4552 0-.2505-.2055-.4551-.4567-.4551h-2.0433v-2.0358c0-.2506-.2056-.4552-.4567-.4552s-.4567.2046-.4567.4552v2.0358h-2.0434c-.2511 0-.4567.2046-.4567.4551 0 .2506.2056.4552.4567.4552h2.0434v2.0358c0 .2506.2056.4551.4567.4551s.4567-.2045.4567-.4551v-2.0358z",
    fill: "#4d4d4d",
    strokeWidth: 0.08
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.7fac36b434fc4db013d9fb1080f6dc52.svg";
export { ForwardRef as ReactComponent };